import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { ListView } from 'antd-mobile';


let data = [
    {
        id: 1,
        img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
        title: 'Meet hotel',
        des: '1六月宁波市疾病预防控制中心健康防病提示六月宁波市疾病预防控制中心健康防病提示',
    },
    {
        id: 2,
        img: 'https://zos.alipayobjects.com/rmsportal/XmwCzSeJiqpkuMB.png',
        title: 'McDonald\'s invites you',
        des: '2不是所有的兼职汪都需要风吹日晒',
    },
    {
        id: 3,
        img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
        title: 'Eat the week',
        des: '3不是所有的兼职汪都需要风吹日晒',
    },
    {
        id: 4,
        img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
        title: 'Meet hotel',
        des: '4不是所有的兼职汪都需要风吹日晒',
    },
    {
        id: 5,
        img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
        title: 'Eat the week',
        des: '5不是所有的兼职汪都需要风吹日晒',
    },
    {
        id: 6,
        img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
        title: 'Meet hotel',
        des: '6不是所有的兼职汪都需要风吹日晒',
    },

];
const NUM_ROWS = 6;
let pageIndex = 0;
function genData(pIndex = 0) {
    const dataBlob = {};
    for (let i = 0; i < NUM_ROWS; i++) {
        const ii = (pIndex * NUM_ROWS) + i;
        dataBlob[`${ii}`] = `row - ${ii}`;
    }
    return dataBlob;
}
export class NewItems extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            data: data.sort()
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.rData = genData();
           
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rData),
                isLoading: false,
                data: data,
            });
        }, 600);
    }
    onEndReached = (event) => {
        let data2 = [
            {
                id: 1,
                img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
                title: 'Meet hotel',
                des: '7六月宁波市疾病预防控制中心健康防病提示六月宁波市疾病预防控制中心健康防病提示',
            },
            {
                id: 2,
                img: 'https://zos.alipayobjects.com/rmsportal/XmwCzSeJiqpkuMB.png',
                title: 'McDonald\'s invites you',
                des: '8不是所有的兼职汪都需要风吹日晒',
            },
            {
                id: 3,
                img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
                title: 'Eat the week',
                des: '9不是所有的兼职汪都需要风吹日晒',
            },
            {
                id: 4,
                img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
                title: 'Meet hotel',
                des: '10不是所有的兼职汪都需要风吹日晒',
            },
            {
                id: 5,
                img: 'https://zos.alipayobjects.com/rmsportal/hfVtzEhPzTUewPm.png',
                title: 'Eat the week',
                des: '11不是所有的兼职汪都需要风吹日晒',
            },
            {
                id: 6,
                img: 'https://zos.alipayobjects.com/rmsportal/dKbkpPXKfvZzWCM.png',
                title: 'Meet hotel',
                des: '12不是所有的兼职汪都需要风吹日晒',
            },];
        // load new data
        // hasMore: from backend data, indicates whether it is the last page, here is false
        if (this.state.isLoading && !this.state.hasMore) {
            return;
        }
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.rData = { ...this.rData, ...genData(++pageIndex) };
            this.setState({
                dataSource: this.state.dataSource.cloneWithRows(this.rData),
                isLoading: false,
                data: data2
            });
        }, 1000);
    }


    render() {
        const { data } = this.state;
        const separator = (sectionID, rowID) => (
            <div
                key={`${sectionID}-${rowID}`}
                style={{
                    backgroundColor: '#F5F5F9',
                    height: 8,
                    borderTop: '1px solid #ECECED',
                    borderBottom: '1px solid #ECECED',
                }}
            />
        );
        let index = data.length - 1;
        const row = (rowData, sectionID, rowID) => {

            if (index < 0) {
                index = data.length - 1;
            }
            const obj = data[index--];
            return (
                <Link key={rowID} to='/new/details'>
                    <div className='newbox'>
                        <div className='textbox'>
                            <div className='title' >{obj.des}</div>
                            <div ><span className='mtime'>{obj.title}</span></div>
                        </div>
                        <img  src={obj.img} alt="" />
                    </div>
                </Link>
            )
        }
        return (
            <ListView
                ref={el => this.lv = el}
                dataSource={this.state.dataSource}

                renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>
                    {this.state.isLoading ? 'Loading...' : 'Loaded'}
                </div>)}
                renderRow={row}
                renderSeparator={separator}
                className="am-list"
                pageSize={4}
                useBodyScroll
                onScroll={() => { console.log('scroll'); }}
                scrollRenderAheadDistance={500}
                onEndReached={this.onEndReached}
                onEndReachedThreshold={10}
                tabBarActiveTextColor='#32a128'
                
            />
        );
    }

}